import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import ProjectModal from "../components/ProjectModal";

const ALL_PROJECTS = [
  // Automotive
  {
    id: "1", title: "Kia India — Pan India Showrooms", category: "commercial", year: 2023,
    coverImage: "/projects/kia_1.jpeg",
    description: "Designed and executed Kia showrooms across India with a consistent brand identity, premium material palette, and customer-centric spatial planning.",
    images: ["/projects/kia_1.jpeg", "/projects/kia_2.jpeg", "/projects/kia_3.jpeg", "/projects/kia_4.jpeg"],
  },
  {
    id: "2", title: "VE Commercial Vehicles — Eicher", category: "commercial", year: 2023,
    coverImage: "/projects/eicher_2.jpeg",
    description: "Regarded as one of the finest projects by Eicher. Designed and executed to outstanding quality with top management inauguration. Delivered within 45 days.",
    images: ["/projects/eicher_2.jpeg", "/projects/eicher_3.jpeg", "/projects/eicher_4.jpeg"],
  },
  {
    id: "3", title: "Hero 2.0 — Showrooms & Workshops", category: "commercial", year: 2024,
    coverImage: "/projects/hero_2.jpeg",
    description: "Completed 40+ Hero and Premia showrooms and workshops across India in 6 months, with a target of 100+ outlets.",
    images: ["/projects/hero_2.jpeg", "/projects/hero_3.jpeg", "/projects/hero_4.jpeg", "/projects/hero_5.jpeg", "/projects/hero_6.jpeg"],
  },
  {
    id: "4", title: "Okinawa Autotech — Dealership Network", category: "commercial", year: 2023,
    coverImage: "/projects/okinawa1_1.jpeg",
    description: "Designed and executed Okinawa corporate and dealership identity. Completed 200 showrooms in 1 year including Galaxy flagship and normal showrooms. Also provided furniture and branding.",
    images: ["/projects/okinawa1_1.jpeg", "/projects/okinawa1_2.jpeg", "/projects/okinawa1_3.jpeg", "/projects/okinawa1_4.jpeg"],
  },
  {
    id: "5", title: "Okinawa Galaxy — Flagship Store", category: "commercial", year: 2023,
    coverImage: "/projects/okinawa_galaxy_1.jpeg",
    description: "The Galaxy flagship showroom for Okinawa Autotech — a premium experiential retail space designed to showcase the full electric vehicle lineup.",
    images: ["/projects/okinawa_galaxy_1.jpeg", "/projects/okinawa_galaxy_2.jpeg", "/projects/okinawa_galaxy_3.jpeg", "/projects/okinawa_galaxy_4.jpeg", "/projects/okinawa_galaxy_5.jpeg", "/projects/okinawa_galaxy_6.jpeg"],
  },
  {
    id: "6", title: "Okinawa Factory", category: "commercial", year: 2022,
    coverImage: "/projects/okinawa_factory_1.jpeg",
    description: "Architectural and interior design support for Okinawa's manufacturing facility, ensuring functional efficiency with brand consistency.",
    images: ["/projects/okinawa_factory_1.jpeg", "/projects/okinawa_factory_2.jpeg", "/projects/okinawa_factory_3.jpeg", "/projects/okinawa_factory_4.jpeg"],
  },
  {
    id: "7", title: "Renault Showroom — Lucknow City", category: "commercial", year: 2022,
    coverImage: "/projects/renault_2.jpeg",
    description: "Bridged the gap between dealer and architect by providing a new GFC set, ensuring the project met brand standards and client expectations.",
    images: ["/projects/renault_2.jpeg", "/projects/renault_4.jpeg", "/projects/renault_5.jpeg", "/projects/renault_6.jpeg"],
  },
  {
    id: "8", title: "MATTER", category: "commercial", year: 2023,
    coverImage: "/projects/ampere_1.jpeg",
    description: "Showroom design for Ampere EV by Greaves — a clean, modern retail environment that highlights the electric mobility brand identity.",
    images: ["/projects/ampere_1.jpeg", "/projects/ampere_2.jpeg", "/projects/ampere_3.jpeg", "/projects/ampere_4.jpeg"],
  },
  {
    id: "9", title: "ALTEGREEN", category: "commercial", year: 2024,
    coverImage: "/projects/matter_1.jpeg",
    description: "Experience hub design for Matter Motors, catering to the North-East and West zones. A futuristic space crafted for immersive EV brand experiences.",
    images: ["/projects/matter_1.jpeg", "/projects/matter_2.jpeg", "/projects/matter_3.jpeg", "/projects/matter_4.jpeg"],
  },
  {
    id: "10", title: "ATHER", category: "commercial", year: 2023,
    coverImage: "/projects/altigreen_2.jpeg",
    description: "Pan India rollout of Altigreen electric commercial vehicle showrooms, balancing brand identity with regional adaptability.",
    images: ["/projects/altigreen_2.jpeg", "/projects/altigreen_3.jpeg", "/projects/altigreen_4.jpeg", "/projects/altigreen_5.jpeg"],
  },
  {
    id: "11", title: "Ather Showroom — Ghaziabad & Dilshad Garden", category: "commercial", year: 2023,
    coverImage: "/projects/ather_2.jpeg",
    description: "Premium Ather Energy showroom designs for Ghaziabad and Dilshad Garden outlets, emphasising the tech-forward brand aesthetic.",
    images: ["/projects/ather_2.jpeg", "/projects/ather_3.jpeg", "/projects/ather_4.jpeg", "/projects/ather_5.jpeg"],
  },
  // Office & Retail
  {
    id: "12", title: "MAPL BOUTIQA — Gurugram, Haryana", category: "interior", year: 2023,
    coverImage: "/projects/vivi_blu_1.jpeg",
    description: "A boutique retail interior in Gurugram — layered textures, warm lighting, and bespoke display fixtures create an elevated shopping experience.",
    images: ["/projects/vivi_blu_1.jpeg", "/projects/vivi_blu_2.jpeg", "/projects/vivi_blu_4.jpeg", "/projects/vivi_blu_5.jpeg"],
  },
  {
    id: "13", title: "MAPL Group Office — Noida", category: "interior", year: 2023,
    coverImage: "/projects/mapl_office_1.jpeg",
    description: "Corporate office design for MAPL Group in Noida — open collaborative zones, executive suites, and brand-forward interiors.",
    images: ["/projects/mapl_office_1.jpeg", "/projects/mapl_office_2.jpeg", "/projects/mapl_office_4.jpeg", "/projects/mapl_office_5.jpeg"],
  },
  {
    id: "14", title: "THE STING OFFICE Noida", category: "interior", year: 2023,
    coverImage: "/projects/mapl_boutique_1.jpeg",
    description: "A premium boutique space for MAPL Group in Noida featuring curated material selections, feature lighting, and tailored millwork.",
    images: ["/projects/mapl_boutique_1.jpeg", "/projects/mapl_boutique_3.jpeg", "/projects/mapl_boutique_4.jpeg", "/projects/mapl_boutique_5.jpeg"],
  },
  {
    id: "15", title: "PUJASHREE OKHLA DELHI", category: "interior", year: 2022,
    coverImage: "/projects/the_sting_1.jpeg",
    description: "A dynamic creative office space in Noida designed with bold interiors, flexible workspaces, and a strong identity-driven design language.",
    images: ["/projects/the_sting_1.jpeg", "/projects/the_sting_3.jpeg", "/projects/the_sting_4.jpeg", "/projects/the_sting_5.jpeg"],
  },
  {
    id: "16", title: "Fitblis — Yasmin Karachiwala Franchise, Bhopal", category: "interior", year: 2023,
    coverImage: "/projects/fitblis_1.jpeg",
    description: "Franchise outlet design for Fitblis, the premium fitness brand by Yasmin Karachiwala, in Bhopal — energetic, functional, and brand-true.",
    images: ["/projects/fitblis_1.jpeg", "/projects/fitblis_3.jpeg", "/projects/fitblis_4.jpeg", "/projects/fitblis_5.jpeg", "/projects/fitblis_6.jpeg"],
  },
  // Residential
  {
    id: "17", title: "Aradhana Apartments — R.K. Puram, New Delhi", category: "residential", year: 2023,
    coverImage: "/projects/aradhana_1.jpeg",
    description: "Comprehensive interior design for Aradhana Apartments in R.K. Puram, New Delhi — a refined residential transformation blending comfort and elegance.",
    images: ["/projects/aradhana_1.jpeg", "/projects/aradhana_2.jpeg", "/projects/aradhana_3.jpeg", "/projects/aradhana_4.jpeg", "/projects/aradhana_5.jpeg"],
  },
  {
    id: "18", title: "Sai Shreeja Villa — Vasant Kunj, New Delhi", category: "residential", year: 2024,
    coverImage: "/projects/sai_shreeja_2.jpeg",
    description: "A luxurious villa in Vasant Kunj featuring a grand entrance, private temple, courtyard, family lounge, and premium suite interiors.",
    images: ["/projects/sai_shreeja_2.jpeg", "/projects/sai_shreeja_3.jpeg", "/projects/sai_shreeja_4.jpeg", "/projects/sai_shreeja_5.jpeg"],
  },
  {
    id: "19", title: "Faridabad Residence", category: "residential", year: 2023,
    coverImage: "/projects/pranav_2.jpeg",
    description: "A bespoke residential interior project delivering tailored spaces that reflect the client's lifestyle with precision and warmth.",
    images: ["/projects/pranav_2.jpeg", "/projects/pranav_3.jpeg", "/projects/pranav_4.jpeg", "/projects/pranav_5.jpeg"],
  },
  {
    id: "20", title: "Penthouse — Noida", category: "residential", year: 2024,
    coverImage: "/projects/penthouse_2.jpeg",
    description: "A high-end penthouse in Noida designed with panoramic views, premium finishes, and a seamless flow between living, dining, and terrace spaces.",
    images: ["/projects/penthouse_2.jpeg", "/projects/penthouse_3.jpeg", "/projects/penthouse_4.jpeg", "/projects/penthouse_5.jpeg"],
  },
   {
    id: "20", title: "WAR MEMORIAL MUSEUM", category: "residential", year: 2026,
    coverImage: "/projects/museum1.jpeg",
    description: "A high-end penthouse in Noida designed with panoramic views, premium finishes, and a seamless flow between living, dining, and terrace spaces.",
    images: ["/projects/museum1.jpeg", "/projects/museum3.jpeg", "/projects/museum4.jpeg","/projects/museum2.jpeg",],
  },
];

const CATEGORIES = [
  { value: "", label: "All" },
  { value: "commercial", label: "Commercial" },
  { value: "residential", label: "Residential" },
  { value: "interior", label: "Interior" },
];

export default function Projects() {
  const [active, setActive] = useState("");
  const [selected, setSelected] = useState(null);

  const projects = active ? ALL_PROJECTS.filter(p => p.category === active) : ALL_PROJECTS;

  return (
    <div className="min-h-screen">
      <Navbar />

      <section className="pt-40 pb-10 px-6 lg:px-12" style={{ background: "var(--color-bg-soft)" }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-xs tracking-widest uppercase text-gray-400 mb-3">Portfolio</div>
          <h1
            className="text-4xl md:text-5xl font-normal text-gray-900 mb-8"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            Our Projects
          </h1>

          {/* Filter tabs */}
          <div className="flex flex-wrap gap-3">
            {CATEGORIES.map(cat => (
              <button
                key={cat.value}
                onClick={() => setActive(cat.value)}
                className={`text-xs tracking-widest uppercase font-medium px-4 py-2 border transition-colors ${
                  active === cat.value
                    ? "bg-gray-900 text-white border-gray-900"
                    : "border-gray-300 text-gray-600 hover:border-gray-900 hover:text-gray-900"
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {projects.length === 0 ? (
            <p className="text-gray-400 text-sm">No projects found.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {projects.map(proj => (
                <div
                  key={proj.id}
                  className="group cursor-pointer"
                  onClick={() => setSelected(proj)}
                >
                  <div className="relative overflow-hidden aspect-[4/3] bg-gray-100">
                    {proj.coverImage ? (
                      <img
                        src={proj.coverImage}
                        alt={proj.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-gray-300 text-5xl">🏛</div>
                    )}
                    <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                      <span className="text-white text-xs tracking-widest uppercase">View Project</span>
                    </div>
                  </div>
                  <div className="mt-3">
                    <h3
                      className="text-sm font-medium text-gray-900"
                      style={{ fontFamily: "var(--font-heading)" }}
                    >
                      {proj.title}
                    </h3>
                    <p className="text-xs text-gray-400 tracking-wide mt-0.5 capitalize">
                      {proj.category} · {proj.year}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
      <FloatingWhatsApp />
      {selected && <ProjectModal project={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}
